import { componentType } from '../helpers';
import { Image } from './image';
export default {
    type: componentType.Image,
    component: Image,
};
